import React from 'react';

export const SvgPaginationNextDisable = () => {
  return (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.52883 7.88453C7.7163 7.697 7.82162 7.44269 7.82162 7.17753C7.82162 6.91236 7.7163 6.65806 7.52883 6.47053L1.87183 0.813528C1.77958 0.718018 1.66924 0.641836 1.54724 0.589427C1.42523 0.537018 1.29401 0.509431 1.16123 0.508278C1.02845 0.507124 0.896773 0.532426 0.773877 0.582707C0.65098 0.632987 0.539328 0.707241 0.445435 0.801133C0.351542 0.895026 0.277289 1.00668 0.227008 1.12957C0.176728 1.25247 0.151426 1.38415 0.15258 1.51693C0.153734 1.64971 0.18132 1.78093 0.233729 1.90293C0.286138 2.02494 0.36232 2.13528 0.45783 2.22753L5.40783 7.17753L0.45783 12.1275C0.275671 12.3161 0.174877 12.5687 0.177156 12.8309C0.179434 13.0931 0.284603 13.3439 0.470011 13.5293C0.655419 13.7148 0.906232 13.8199 1.16843 13.8222C1.43063 13.8245 1.68323 13.7237 1.87183 13.5415L7.52883 7.88453Z"
        fill="#959091"
      />
    </svg>
  );
};

export const SvgPaginationNext = () => {
  return (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.52883 7.88453C7.7163 7.697 7.82162 7.44269 7.82162 7.17753C7.82162 6.91236 7.7163 6.65806 7.52883 6.47053L1.87183 0.813528C1.77958 0.718018 1.66924 0.641836 1.54724 0.589427C1.42523 0.537018 1.29401 0.509431 1.16123 0.508278C1.02845 0.507124 0.896773 0.532426 0.773877 0.582707C0.65098 0.632987 0.539328 0.707241 0.445435 0.801133C0.351542 0.895026 0.277289 1.00668 0.227008 1.12957C0.176728 1.25247 0.151426 1.38415 0.15258 1.51693C0.153734 1.64971 0.18132 1.78093 0.233729 1.90293C0.286138 2.02494 0.36232 2.13528 0.45783 2.22753L5.40783 7.17753L0.45783 12.1275C0.275671 12.3161 0.174877 12.5687 0.177156 12.8309C0.179434 13.0931 0.284603 13.3439 0.470011 13.5293C0.655419 13.7148 0.906232 13.8199 1.16843 13.8222C1.43063 13.8245 1.68323 13.7237 1.87183 13.5415L7.52883 7.88453Z"
        fill="#514B4D"
      />
    </svg>
  );
};
